import {
    Component,
    OnInit,
    Input,
    OnChanges,
    Output,
    EventEmitter} from '@angular/core';
import { FilterOptions, Indicatori, StepComponents, ToolTable, ToolTableBody, Cell, Table } from '../../models';
import { ScenarioComponent } from 'src/app/models/tool.model';
import { ToastService } from '../../services';


@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: false
})

export class TableComponent implements OnInit, OnChanges {

  @Input() data: ToolTable;
  @Input() actualIndicator: string;
  @Input() indicators: Indicatori[];
  @Input() key: string;
  @Input() filters: FilterOptions[];
  @Input() info: StepComponents;
    @Input() referenceYears?: string[] | undefined;
    @Input() memoryCells_permanent_memory?: boolean = false; // @@NLLChanges@@ @@createdbybamba@@ se questo parametro è true =>  nel caso la tabella contenga componenti di tipo app-cell-manual-edit queste rimangono colorate in eterno.


  timer: number; 
  delay: number = 800;
  isReferenceYearListAvailable?: boolean | undefined;


  auto: boolean;
  @Input('auto') set setAuto(attribute: boolean | '') {
    this.auto = attribute === '' || attribute;
  }

  isSimpleTable: boolean;
  @Input('isSimpleTable') set setIsSimpleTable(attribute: boolean | '') {
    this.isSimpleTable = attribute === '' || attribute;
  }

  @Output() sendData: EventEmitter<ScenarioComponent> = new EventEmitter();

  @Output() setReferenceYear: EventEmitter<string> = new EventEmitter();

  @Output() sendTaxonomyChanged = new EventEmitter<boolean>();

  title: string;
  subtitle: string;
  viewMore = 20;
  getAllRows = false;
  isDropdownClosed = true;
  isNameNotNull: boolean;
  referenceYear: string | undefined;
  rowStatusList: {[id: number] : number} = [];
  columnStatusList: {[id: number] : number} = [];

    constructor(private toast: ToastService) { }

  ngOnInit() { }

  ngOnChanges() {

    if(this.referenceYears) {
      this.isReferenceYearListAvailable = this.referenceYears? this.referenceYears.length>0 : false;
      this.referenceYear = this.referenceYears? this.referenceYears[0] : undefined;
    }


    if (this.filters) {
      this.title = this.filters.filter(filter => filter.type === this.key)[0].name;
    }
    if (this.indicators && this.indicators.length > 0) {
      this.subtitle = this.indicators.filter(indicator => indicator.type === this.actualIndicator)[0].name;
    }
    if (this.data?.table && this.data.table.header) {
      this.isNameNotNull = !!this.data.table?.header[0].name || this.data.table?.header[0].name !== null;
    }
    
    if (this.info?.component_type === 'tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili' ) {
      this.data?.table?.header.forEach((col, columnIndex) =>{ col.name = this.checkAllSelectedCellByColumn(columnIndex)});

      this.data?.table?.body.map((row, rowIndex) => row.is_selected = this.checkAllSelectedCellByRow(row, rowIndex));
    }

    if (Boolean(this.auto) && this.info) {
      this.title = this.info.component_title;
      this.subtitle = this.info.component_subtitle;
    }
  }

  onCell($event: Cell, row?: ToolTableBody, cellIndex?: number) {
    if (this.info?.component_type === 'tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili' ) {
      row.is_selected = this.checkAllSelectedCellByRow(row, (this.data.table.body.length - row.values.length));
    }

    if (cellIndex) {
      if (cellIndex in this.data.table.header) {
        this.data.table.header[cellIndex].name = this.checkAllSelectedCellByColumn(cellIndex);
      }
    
    }
      if (row && row.only_one_selected) {
          //if (row.only_one_selected === true && !$event.is_checked) return;
      if ($event.blocked) {
        delete $event.blocked;
        window.clearTimeout(this.timer);
        this.timer =  window.setTimeout(() => {this.sendData.emit({ component: this.info, data: this.data.table })}, this.delay);
        return;
        }


        

      if(row.only_one_selected === true){
        row.values.map(item => {
            if (item.value !== $event.value) {
                item.is_checked = false;
            } else {
                item.is_checked = true;
            }
        });
      }

      }
      if (this.key === 'manage_taxonomies_modal') {
          this.sendTaxonomyChanged.emit($event.is_edited);
      } else {

     
    window.clearTimeout(this.timer);
          this.timer = window.setTimeout(() => { this.sendData.emit({ component: this.info, data: this.data.table }) }, this.delay);
      }
    }

    checkWithModal(myKey?: string): boolean {
        if (myKey !== undefined) {
            if (myKey === 'manage_taxonomies_modal') {
                return false;
            }
        }
        return true;
    }
  /**
   * Select/deselect the row in the table of type table_with_selectable_lines
   * and send the information and the table component to the parent component
   * @param body Selected/deselected row
   */

  onSelectedRow(body: ToolTableBody, tableIndex?: number, tableType?: string) {
    if (tableIndex >= 0){  
      switch (tableType)
      {
        case 'tabella_con_righe_colonne_selezionabili': {
          this.data.table.body[tableIndex].values.map((cell, cellIndex) => {
            cell.is_checked = !body.is_selected;
            this.data.table.header[cellIndex].name =
            typeof this.data.table.header[cellIndex].name !== 'string' ?
            this.checkAllSelectedCellByColumn(cellIndex) :
            this.data.table.header[cellIndex].name;
          });
          break;
        }         
        case 'tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili':{
          this.data.table.body[tableIndex].values.map((cell, cellIndex) => {
            cell.is_checked = !body.is_selected;
            this.data.table.header[cellIndex].name =
            typeof this.data.table.header[cellIndex].name !== 'string' ?
            this.checkAllSelectedCellByColumn(cellIndex) :
            this.data.table.header[cellIndex].name;
          });
          this.checkAllSelectedCellByRow(this.data.table.body[tableIndex], tableIndex)
          break;
        }
        default: {
          break;
        }
      }
    }

    if(this.data.table.body[0].only_one_selected !== undefined){
      this.data.table.body.map(item => {
        item.name === body.name ? item.is_selected = !item.is_selected : item.is_selected = item.only_one_selected? false :item.is_selected;
      });
    }
    else{
      this.data.table.body.map(item => {
        item.name === body.name ? item.is_selected = !item.is_selected : item.is_selected = false;
      });
    }

    window.clearTimeout(this.timer);
    this.timer =  window.setTimeout(() => {this.sendData.emit({ component: this.info, data: this.data.table })}, this.delay);
  }

  /**
   * It manages the collapsing of the rows of some tables that exceed 20 rows
   */

  getAllTablesRow() {
    this.getAllRows = !this.getAllRows;
    this.viewMore = this.getAllRows ? this.data.table.body.length : 20;
  }

  /**
   * It intercepts the event triggered by the closing of the dropdown
   * of the cella_dropdown and sets the table overflow
   * @param $event Event triggered by cell_dropdown
   */

  handleOverflowOnTable($event) {
    this.isDropdownClosed = $event;
    const wrapper = document.getElementsByClassName('process-wrapper')[0];
    if ($event) {
      (wrapper as HTMLElement).style.overflow = 'unset';
    } else {
      (wrapper as HTMLElement).style.overflow = 'hidden';
    }
  }

  getColumnType(column: string | boolean) {
    return typeof column === 'boolean';
  }

  onSelectedColumn(headerName: string | boolean, headerIndex: number, mutuallyExclusion: boolean) {
    if(mutuallyExclusion){
      this.data.table.body.map(row=> 
        row.values.forEach(value => value != undefined ? value.is_checked = false : null)
      )

      this.data.table.header.forEach(h => h.name === "" ? "" : h.name = false);

      this.data.table.header[headerIndex].name = true;

      this.data.table.body.map(row => row.values[headerIndex] != undefined ? row.values[headerIndex].is_checked = true : null);
    } 
    else{
      this.data.table.header[headerIndex].name = (headerName as boolean);
      this.data.table.body.map(row => row.values[headerIndex] != undefined ? row.values[headerIndex].is_checked = (this.data.table.header[headerIndex].name as boolean) : null);   
    }   

    if (this.info?.component_type === 'tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili' ) {
      this.data?.table?.body.map((row, rowIndex) => row.is_selected = this.checkAllSelectedCellByRow(row, rowIndex))
      this.checkAllSelectedCellByColumn(headerIndex);
    }

    window.clearTimeout(this.timer);
    this.timer =  window.setTimeout(() => {this.sendData.emit({ component: this.info, data: this.data.table })}, this.delay);
  }

  checkAllSelectedCellByColumn(cellIndex: number) {
    // variabile locale per lo stato 0 = false, 1 = true, 2 = partial
    let status = 0;
    if((this.data.table.body.filter(row => row.values[cellIndex]?.is_checked === true || row.values[cellIndex] === undefined).length) === this.data.table.body.length) {
      status = 1;
    }
    else if((this.data.table.body.filter(row => row.values[cellIndex]?.is_checked === true).length) === 0) {
      status = 0;
    }
    else {
      status = 2;
    }

    this.columnStatusList[cellIndex] = status;
    return this.columnStatusList[cellIndex] == 1? true : (this.columnStatusList[cellIndex] == 0? false : false);
  }

  checkAllSelectedCellByRow(row:ToolTableBody, rowIndex: number) {
    // variabile locale per lo stato 0 = false, 1 = true, 2 = partial
    let status = 0;
    if(row.values.filter(column => column?.is_checked === true).length === row.values.length)
    {
      status = 1;
    }
    else if(row.values.filter(column => column?.is_checked === true).length === 0) {
      status = 0;
    }
    else {
      status = 2;
    }

    this.rowStatusList[rowIndex] = status;   
    return this.rowStatusList[rowIndex] == 1? true : (this.rowStatusList[rowIndex] == 0? false : false);
  }


  isPercentageColumn(percentageString:string): boolean{    
    return percentageString === '%';
  }

    onChangePercentageColumnValue(tableIndex: number, headerIndex: number, percentageValue: number) {
        if (percentageValue < 0) {
            this.toast.showError({ status: 'Error', detail: "Please insert a value greater then 0" });
                return;
        } 
    let indiceColonna : number = headerIndex;
    let percentageString = "" + percentageValue;
    for(let i = 0;i<tableIndex; i++){
      indiceColonna += this.data.table.header[i].colonne.length;
    }    

    this.data.table.body.map(row => row.values[indiceColonna] != undefined ? row.values[indiceColonna].value = percentageString: null);
    window.clearTimeout(this.timer);
    this.timer =  window.setTimeout(() => {this.sendData.emit({ component: this.info, data: this.data.table })}, this.delay);
  }

  changeReferenceYear(referenceYear:string){
    this.setReferenceYear.emit(referenceYear);
  }
}
